import * as SaveStatusActions from '../actions/savedStatusActions';
import {SaveStatusActionTypes} from "../actions/savedStatusActions";


export type SavedStatusState = Array<{
    page: string,
    id: string,
    messages: Array<{id: string, message: string}>
}>;

export type SavedStatusAction = {
    type: SaveStatusActionTypes,
    payload: {
        page: string,
        id: string,
        message: string,
        messageIds: Array<string>
    }
};

function savedStatus(state: SavedStatusState = [], action: SavedStatusAction) {
    const st = [...state];

    switch (action.type) {
        // Set the save status of a page. If messages were sent, add them to the existing entry.
        case SaveStatusActions.START_EDITING: {
            // Add this combination if it doesn't already exist. If it does exist, update the messages.
            const found = st.find(entry => entry.page === action.payload.page && entry.id === action.payload.id);

            // If not found, just add it to the state
            if (!found) {
                st.push({page: action.payload.page, id: action.payload.id, messages: []});
            }

            return st;
        }

        // Stop editing the page by removing it from the state.
        case SaveStatusActions.STOP_EDITING: {
            const index = st.findIndex(entry => entry.page === action.payload.page && entry.id === action.payload.id);
            if (index > -1) {
                st.splice(index, 1);
            }
            return st;
        }

        // Find the message and remove it from the state
        case SaveStatusActions.REMOVE_MESSAGES: {
            if(action.payload.messageIds) {
                action.payload.messageIds.forEach(msgId => {
                    // Add this combination if it doesn't already exist. If it does exist, update the messages.
                    const messageIndex = st.findIndex(entry => entry.messages.find(msg => msg.id === msgId));

                    if (messageIndex >= 0) {
                        const found = st.find(entry => entry.page === action.payload.page && entry.id === action.payload.id);
                        if (found) found.messages.splice(messageIndex, 1);
                    }
                });
            }
            else {
                console.error('No payload?', action);
            }

            return st;
        }

        default:
            return state;
    }
}

export default savedStatus;
